export const API_BASE = process.env.REACT_APP_API_BASE || 'https://asynscale.ai';

export const API_ENDPOINTS = {
  login: '/api/login',
  register: '/api/register',
  // 下面是修改后的 endpoints
  allCompetitions: '/api/all-competition',
  allTeams: (competitionId) => `/api/all-teams/${competitionId}`,
  joinCompetition: '/api/join-competition',
  joinTeam: '/api/join-team',
  createTeam: '/api/create-team',
  allApplications: (competitionId) => `/api/all-applications/${competitionId}`,
  reviewApplication: '/api/review-application',
  leaderboard: (competitionId) => `/api/leaderboard/${competitionId}`,
  leaderboardDetail: (competitionId) => `/api/leaderboard/detail/${competitionId}`,
  profile: '/api/me',
  userHistory: (competitionId) => `/api/leaderboard/detail/${encodeURIComponent(competitionId)}`,
  userTeamStatus: (competitionId) => `/api/my-team/${competitionId}`,
  // 新增视频相关接口
  videoStream: (competitionId, routeId, jsonFile, videoType = 'front') => 
    `/api/leaderboard/detail/video/${competitionId}/${routeId}/${jsonFile}/${videoType}`,
  videoDownload: (competitionId, routeId, jsonFile, videoType = 'front') => 
    `/api/leaderboard/detail/video-download/${competitionId}/${routeId}/${jsonFile}/${videoType}`
};

export const STORAGE_KEYS = {
  isLoggedIn: 'isLoggedIn',
  username: 'username',
  accessToken: 'accessToken',
  registryUrl: 'registryUrl',
  role: 'role'
};

export const USER_ROLES = {
  user: 'user',
  competitionAdmin: 'competition_admin',
  siteAdmin: 'site_admin'
};

export const MOCK_COMPETITIONS = [
  {
    id: 1,
    name: 'Bench2Drive 城市挑战赛',
    description: '复杂城市交通场景，多路线组合测试。',
    owner: 'admin',
    deadline: '2026-03-01',
    status: 'active',
    statusLabel: '进行中',
    isMember: true
  }
  // {
  //   id: 2,
  //   name: '高速路智能驾驶赛',
  //   description: '高速路场景下的安全性与舒适性评估。',
  //   owner: 'speed_admin',
  //   deadline: '2026-02-20',
  //   status: 'upcoming',
  //   statusLabel: '即将开始',
  //   isMember: false
  // },
  // {
  //   id: 3,
  //   name: '雨夜极限挑战赛',
  //   description: '极端天气场景测试，重点考察感知鲁棒性。',
  //   owner: 'rain_admin',
  //   deadline: '2026-01-15',
  //   status: 'closed',
  //   statusLabel: '已结束',
  //   isMember: true
  // }
];

export const TEAM_SIZE_LIMITS = {
  min: 1,
  max: 6
};

export const MOCK_TEAMS = [
  {
    id: 1,
    name: '智行者小队',
    capacity: 5,
    members: ['alice', 'bob', 'carol'],
    owner: 'alice'
  },
  {
    id: 2,
    name: '未来出行组',
    capacity: 4,
    members: ['david', 'emma', 'frank', 'gina'],
    owner: 'david'
  },
  {
    id: 3,
    name: '极速智驾',
    capacity: 6,
    members: ['henry'],
    owner: 'henry'
  },
  {
    id: 4,
    name: '雨夜先锋',
    capacity: 3,
    members: ['irene', 'jack', 'karen'],
    owner: 'irene'
  }
];

export const MOCK_JOIN_REQUESTS = [
  {
    id: 1,
    applicant: 'lucas',
    teamName: '智行者小队',
    message: '希望加入团队一起参赛'
  }
];

export const MOCK_TEAM_MEMBERS = {
  admin: ['admin', 'alice', 'bob'],
  '智行者团队': ['alice', 'bob', 'carol'],
  '自动驾驶先锋': ['david', 'emma'],
  '未来出行': ['frank', 'gina', 'henry'],
  '极速智驾': ['irene', 'jack', 'karen']
};
